<div class="licensed-add" fxLayout="column" fxLayoutGap="5px" >

  <div fxLayout="row" >
      <h2>Licencje Agent21</h2>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="closeDialog('')" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
  <mat-card>
  <div  fxLayout="column" fxFlex="100">
    <div fxLayout="row" fxLayoutGap="5px">
      <h3 >Dane </h3>
    </div>
    <div fxLayout="row" fxLayoutGap="5px">
      <div  fxFlex="50">
        <mat-form-field  fxFlex="100">
          <mat-label>NIP do licencji</mat-label>
          <input matInput  [formControl]="licenseNipControl" [required]="true" mask="0000000000">
          <mat-error *ngIf="licensedAgentForm.get('licenseNip').hasError('required')">To pole jest wymagane</mat-error>
          <mat-error *ngIf="licensedAgentForm.get('licenseNip').hasError('invalidNip')">Podaj prawidłowy numer NIP</mat-error>
          <mat-error *ngIf="licensedAgentForm.get('licenseNip').hasError('backendError')">{{errors.nip}}</mat-error>
        </mat-form-field>
      </div>
      <div  fxFlex="50">
        <mat-form-field fxFlex="100">
          <mat-label>NIP do faktury</mat-label>
          <input matInput  [formControl]="invoiceNipControl" [required]="true" mask="0000000000">
          <mat-error *ngIf="licensedAgentForm.get('invoiceNip').hasError('required')">To pole jest wymagane</mat-error>
          <mat-error *ngIf="licensedAgentForm.get('invoiceNip').hasError('invalidNip')">Podaj prawidłowy numer NIP</mat-error>
          <mat-error *ngIf="licensedAgentForm.get('invoiceNip').hasError('backendError')">{{errors.nip}}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row" fxLayoutGap="5px">
      <app-dict  fxFlex="100" [label]="'Płatnik licencji'" [dictType]="'contract_owner'"
                 [formControl]="licensePayerControl" [required]="true"></app-dict>
      <!--      <mat-form-field fxFlex="89">-->
      <!--        <mat-label>Płatnik licencji</mat-label>-->
      <!--        <mat-select [formControl]="licensePayerControl">-->
      <!--          <mat-option *ngFor="let val of licensePayers" [value]="val.value">-->
      <!--            {{val.viewValue}}-->
      <!--          </mat-option>-->
      <!--        </mat-select>-->
      <!--      </mat-form-field>-->
    </div>

    <div fxLayout="row"  fxLayoutGap="5px" *ngIf="ofwca">
      <div fxFlex="100">
        <app-dict-ofwcas fxFlex="100" label="OFWCA"
                         [control]="ofwcaControl"
                         [required]="true"
                         [ofwcaItems]="partnerOfwca">
        </app-dict-ofwcas>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="5px">
      <h5 fxFlex>Adres mailowy</h5>
      <div class="list-add-button">
        <button (click)="addEmail('emails')" mat-icon-button color="primary">
          <mat-icon>add_box</mat-icon>
        </button>
      </div>
    </div>
    <div fxLayout="row" *ngIf="licensedAgentForm.get('emails').hasError('minLength')">
      <mat-error>
        Musisz podać przynajmniej jeden adres podstawowy
      </mat-error>
    </div>
    <div fxLayout="column" fxFlex="100">
      <ng-container  *ngFor="let formGroup of emails; index as i">
        <div fxLayout="row" fxLayoutGap="5px" [formGroup]="formGroup">
          <input type="hidden" formControlName="uuid">
          <div fxFlex="50">
            <div fxFlex="6" class="list-counter">
              {{i+1}}.
            </div>
            <div fxFlex="100">
              <mat-form-field class="add-input">
                <mat-label>Adres</mat-label>
                <input matInput placeholder="adres@asf.com.pl" formControlName="email" [required]="true">
                <mat-error *ngIf="formGroup.get('email').hasError('required')">To pole jest wymagane</mat-error>
                <mat-error *ngIf="formGroup.get('email').hasError('email')">Podaj poprawny adres email</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div fxFlex="50" fxLayoutGap="5px">
            <div fxFlex="100">
              <mat-form-field class="add-input">
                <mat-label>Nazwa</mat-label>
                <input matInput placeholder="Nazwa" formControlName="name" [required]="false">
              </mat-form-field>
            </div>

            <div fxFlex="5" class="list-remove-button">
              <button (click)="removeEmail(i, 'emails')" mat-icon-button color="warn">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

        </div>
      </ng-container>


      <div fxLayout="row"  fxLayoutGap="15px">
        <h5 fxFlex>Nr telefonu</h5>
        <div class="list-add-button">
          <button (click)="addPhone('phones')" mat-icon-button color="primary">
            <mat-icon>add_box</mat-icon>
          </button>
        </div>
      </div>
      <div fxLayout="row" *ngIf="licensedAgentForm.get('phones').hasError('minLength')">
        <mat-error>
          Musisz podać przynajmniej jeden numer podstawowy
        </mat-error>
      </div>
      <div fxLayout="column" fxFlex="100">
        <ng-container  *ngFor="let formGroup of phones; index as i">
          <div fxLayout="row" fxLayoutGap="5px" [formGroup]="formGroup">
            <input type="hidden" formControlName="uuid">
            <div fxFlex="50">
              <div fxFlex="6" class="list-counter">
                {{i+1}}.
              </div>
              <div fxFlex="100">
                <mat-form-field class="add-input">
                  <mat-label>Numer</mat-label>
                  <input matInput placeholder="+48 500 200 300" formControlName="phone" [required]="true" prefix="+48" mask=" 000 000 000">
                  <mat-error *ngIf="formGroup.get('phone').hasError('required')">To pole jest wymagane</mat-error>
                  <mat-error *ngIf="formGroup.get('phone').hasError('invalidPhoneNumber')">Podaj poprawny numer telefonu</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxFlex="50" fxLayoutGap="5px">
              <div fxFlex="100">
                <mat-form-field class="add-input">
                  <mat-label>Nazwa</mat-label>
                  <input matInput placeholder="Nazwa" formControlName="name" [required]="false">
                </mat-form-field>
              </div>

              <div fxFlex="5" class="list-remove-button">
                <button (click)="removePhone(i, 'phones')" mat-icon-button color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>

          </div>
        </ng-container>
      </div>
    </div>
  </div>
  </mat-card>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="closeDialog('')" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
